/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, {useState} from 'react';
import { useParams, useLocation } from 'react-router-dom';

/* APP / CONTEXTOS */

import ProgramasController from '../../servicos/programas/ProgramasController';
import { IRetornoAjaxProgramas, IProgramasData } from '../../servicos/programas/Programas_FrontAPI';

/* COMPONENTES */

import LoadingSkeleton from '../../componentes/tabelas/LoadingSkeleton.tsx';
import AlertDialog, { IAlertConfirmDelegate } from '../../componentes/widgets/AlertConfirm.tsx';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import {ESTATUSFILTER, ETIPOFILTER, IPropsFilterObj, objFilterDefault} from '../../componentes/tabelas/TableFilter';

/* INTERFACES / ENUMERAÇÕES */

import FormDialog from './formDialog.tsx';
import ListComponent from '../../componentes/lists/_ListComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM';

import { ColumnTypes, ETABLE, ITableFilter, ITablePaginacao, Order } from '../../componentes/tabelas/ITabelas.ts';
import { areAllValuesEmpty } from '../../AppConfig.ts';
import { isEmpty, isNumber } from 'lodash';
import { IFormStatePrograma } from 'src/servicos/IFormularios.ts';

interface IPageContexto
{
	_handleAdd?: any
	_handleEdit?: any
	_handleView?: any
	_handleExclude?: any
}

const PageContext = React.createContext<IPageContexto|undefined>(undefined);

const ListaProgramas = () =>
{
	const ProgController = new ProgramasController();
	
	const [ehCarregado, setEhCarregado] = useState<boolean>(false);
	const [deleting, setDeleting] = useState<boolean>(false);
	const [bananinhaDelegate, setBananinhaDelegate] = useState<IBananinhaDelegate|undefined>(undefined);
	const [alertConfirmDelegate, setAlertConfirmDelegate] = useState<IAlertConfirmDelegate|undefined>(undefined);
	const [listaPaginada, setListaPaginada] = useState<IProgramasData[]|null>(null);
	const [openDialog, setOpenDialog] = React.useState(false);
	const [statusActionButtons, setStatusActionButtons] = React.useState(true);

	const [formEntidade, setFormEntidade] = React.useState<IFormStatePrograma>(null);
	const [formView, setFormView] = React.useState<boolean>(false);

	const [pager, setPager] = useState<ITablePaginacao|null>(null);
	const [pageNumber, setPageNumber] = React.useState<number>();
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(20);
	const [order, setOrder] = React.useState<Order>('desc');
	const [orderBy, setOrderBy] = React.useState<ColumnTypes | undefined>(undefined);
	const [filtroHead, setFiltroHead] = React.useState<ITableFilter | undefined>();

	const [dataFilter, setDataFilter] = React.useState<IPropsFilterObj>(objFilterDefault);
	const [drawerFilterStatus, setDrawerFilterStatus] = React.useState<ESTATUSFILTER>(ESTATUSFILTER.INICIAL);

	//#region [FUNÇÕES]

		const _handleAdd = () =>
		{
			const entidade: IFormStatePrograma = { idRepositorio: null }
			setFormEntidade(entidade);
			setFormView(false)
			setOpenDialog(true);
		}
		const _handleEdit = async(entidade:IFormStatePrograma) =>
		{
			// A API de lista parece não trazer os dados filhos quando não se consulta pelo ID. Por isso, é necessário um GET pelo ID neste ponto:
			entidade = await getEdit(entidade);
			setFormEntidade(entidade);
			setFormView(false)
			setOpenDialog(true);
		}
		const _handleView = async(entidade:IFormStatePrograma) =>
		{
			entidade = await getEdit(entidade);
			setFormEntidade(entidade);
			setFormView(true)
			setOpenDialog(true);
		}
		React.useEffect(() =>
		{
			setFormEntidade(formEntidade)
		},[formEntidade])

		const _delete = React.useCallback( async (ID: string) => 
		{
			setDeleting(true);
			setEhCarregado(false);
			
			try
			{
				const res:IRetornoAjaxProgramas = await ProgController.programasDelete(ID);
				if (res && res.status == 200)
				{
					// Se página atual = última página e só tem 1 item na página
					if (isNumber(pageNumber) && isNumber(rowsPerPage) && pageNumber == pager.total_pages && ((pager.total_items % rowsPerPage) == 1 )) {
						setPageNumber(Math.max(1, pageNumber - 1))
					}

					if(listaPaginada.length > 1)
						bananinhaDelegate?.abrir("Item excluído com sucesso.", "success");
				}
				else
				{
					setEhCarregado(true);
					bananinhaDelegate?.abrir(res.message, "error");
				}
			}
			catch(e)
			{
				setEhCarregado(true);
				bananinhaDelegate?.abrir(e, "error");
			}
			finally
			{
				setDeleting(false);
			}

			return '';
		}, [bananinhaDelegate, pageNumber, pager, rowsPerPage]);

		const _handleExclude = React.useCallback((ID: string, Name: string) =>
		{
			alertConfirmDelegate?.abrir(
				"Confirme a exclusão", 
				'Deseja realmente excluir o item "' + Name + '"?',  
				(bln:any) => 
				{
					if(bln) _delete(ID)
				}
			)
		}, [alertConfirmDelegate, _delete])

		React.useEffect(() =>
		{
			if(!deleting)
			{
				getList()
			}
		},[deleting])

		const getList = async (callbackDataFilter?:IPropsFilterObj, rowsNum?:number, pageNum?:number, orderby?:string, order?:Order, sortParameter?: string) =>
		{	
			try
			{
				// console.log('getList', callbackDataFilter, rowsNum, pageNum, orderby, order, sortParameter);
				setEhCarregado(false);
				const res:IRetornoAjaxProgramas = await ProgController.programasList(undefined, callbackDataFilter || dataFilter, rowsNum || rowsPerPage, pageNum || pageNumber,orderby,order,sortParameter);			
				if (res.Data?.rows) {
					setDrawerFilterStatus(ESTATUSFILTER.INICIAL);
					if (res.Data?.rows?.length > 0)
					{
						setListaPaginada(res.Data?.rows);					
						if (res?.pager)
						{
							setPager(res?.pager);
							setPageNumber(res.pager.current_page);
							setRowsPerPage(res.pager.items_per_page);
						}
					}
					else
					{
						setListaPaginada([]);
						setPager(null);
						setPageNumber(1);
						bananinhaDelegate?.abrir('Nenhum resultado encontrado.', "error");
					}
				}
			}
			catch(e)
			{
				bananinhaDelegate?.abrir(e, "error");
			}
			finally
			{
				setEhCarregado(true);
			}
		}
		const getEdit = async (entidade:IFormStatePrograma) =>
		{
			try
			{
				const res:IRetornoAjaxProgramas = await ProgController.programasList(entidade.idPrograma);
				if (res.status == 200 && res.Data) {
					entidade = res.Data as unknown as IFormStatePrograma
				}
				else {
					bananinhaDelegate?.abrir(res.message, "error");
				}
			}
			catch(e)
			{
				bananinhaDelegate?.abrir(e, "error");
			}
			finally
			{
				return entidade;
			}
		}

		React.useEffect(() =>
		{
			setDrawerFilterStatus(ESTATUSFILTER.FECHADO);
		},[ehCarregado])

		const { idPrograma } = useParams<{ idPrograma: string }>();
		const location = useLocation();
		const queryParams = new URLSearchParams(location.search);
		React.useEffect(() =>
		{
			// Convert idPrograma to a number
			const idProgramaNumber = Number(idPrograma);
			const viewParam = queryParams.get('view');

			if (!isNaN(idProgramaNumber) && !viewParam) {
				var entidade: IFormStatePrograma = { idPrograma:idProgramaNumber, idRepositorio:null };
				_handleEdit(entidade);
			}else if(!isNaN(idProgramaNumber)){
				var entidade: IFormStatePrograma = { idPrograma:idProgramaNumber, idRepositorio:null };
				_handleView(entidade);
			}
		}, [idPrograma])	

	//#endregion

	return <>
		<PageContext.Provider value={{ _handleAdd: _handleAdd, _handleEdit: _handleEdit, _handleExclude: _handleExclude, _handleView: _handleView}}>
			<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
			<AlertDialog getDelegate={delegate => alertConfirmDelegate ?? setAlertConfirmDelegate(delegate)}/>
				{(ehCarregado && listaPaginada && !deleting && drawerFilterStatus) ?
				<PageContext.Consumer>{ctx => (
					<ListComponent 
						titulo="Programas"
						addHandleAdd={() => ctx?._handleAdd()}
						addUrl={null}
						addEhNovaJanela={false}
						lstTipo={ETABLE.PROGRAMAS}
						lstListaPaginada={listaPaginada}
						lstPaginacao={pager}
						lstPageNumber={pageNumber}
						lstRowsPerPage={rowsPerPage}
						lstSetup={[
							// { id: 'idPrograma',				numeric: false,	label: 'ID' },
							{ id: 'titulo',					numeric: false,	label: 'Título',				sort: true,		align: 'left' },
							{ id: 'tipoPrograma',			numeric: false,	label: 'Tipo de programa',		sort: true,	align: 'left' },
							{ id: 'tipoMidia',				numeric: false,	label: 'Tipo de mídia',			sort: true,	align: 'left' },
							{ id: 'serie.titulo',			numeric: false,	label: 'Série',					sort: true,	align: 'left' },
							{ id: 'numeroEpisodio',			numeric: false,	label: 'Episódio',				sort: true },
							{ id: 'anoProducao',			numeric: false,	label: 'Ano de produção',		sort: true },
							{ id: 'classificacaoEtaria',	numeric: false,	label: 'Classificação etária',	sort: true,	align: 'left' },
							// { id: 'idGsatIdFrm',				numeric: false,	label: 'ID GSAT/FRM',				sort: false },
							{ id: 'dataCadastro',				numeric: false,	label: 'Cadastrado em',					sort: true },
							{ id: 'dataAlteracao',			numeric: false,	label: 'Alterado em',				sort: true }
						]}
						lstHandleEdit={(props) => ctx?._handleEdit(props)}
						lstHandleView={(props) => ctx?._handleView(props)}
						lstHandleDelete={(id, name) => ctx?._handleExclude(id, name)}
						lstFieldID="idPrograma"
						lstFieldName="titulo"
						lstCallback={async (rowsNum, pageNum, orderby, order) => 
							{
								setEhCarregado(false);
								setRowsPerPage(rowsNum);
								setPageNumber(pageNum);
								await getList(undefined, rowsNum, pageNum, orderby, filtroHead?.order, filtroHead?.titulo);
							}}
						fltVisivel={true}
						fltTipoForm={ETIPOFILTER.PROGRAMAS}
						fltFilterDefault={dataFilter}
						fltStatus={drawerFilterStatus}
						fltFilterList={[
							'titulo', 
							'tipoPrograma',
							'tipoMidia', 
							'idSerie',
							'numeroEpisodio', 
							'anoProducao', 
							'classificacaoEtaria', 
							'idGsatIdFrm', 
							'vigencia', 
							'licenciamento',
							'versao',
							'idiomaVersao',
							'sinopse',
							'sinopseIdioma',
							'palavraChave'
						]}
						fltCallback={async (dataFilterReturn:IPropsFilterObj) => 
							{
							setPageNumber(1);
							if (dataFilterReturn && !areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter(dataFilterReturn);
								await getList(dataFilterReturn, undefined, 1, orderBy, order, filtroHead?.titulo);
							}										
							else if (dataFilterReturn && areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter(objFilterDefault);
								getList(objFilterDefault, undefined, 1, orderBy, order, filtroHead?.titulo);
							}
							else
								bananinhaDelegate?.abrir('Ocorreu um erro. Não foi possível filtrar.', "error");
							setDrawerFilterStatus(ESTATUSFILTER.FECHADO)
						}}
						lstOrderHeranca={order}
						lstOrderByHeranca={orderBy}
						lstCallbackFilter={async (event: React.MouseEvent<unknown>, filter: ITableFilter, orderBy?: string) =>
							{
								console.log('Filter clicked:', filter, orderBy);
								if (filter && orderBy) {
									setOrderBy(orderBy as ColumnTypes);
									setPageNumber(1);
									setFiltroHead(filter);
									if (filter.order === 'asc') {
										await getList(dataFilter, rowsPerPage, 1, orderBy, 'asc', filter?.titulo);
										setOrder(filter.order);
									}if (filter.order === 'desc') {
										await getList(dataFilter, rowsPerPage, 1, orderBy, 'desc', filter?.titulo);
										setOrder(filter.order);
									}
								}
							}
						}
					>
						<></>
					</ListComponent>
				)}</PageContext.Consumer>
				:
				<LoadingSkeleton columns={10} />
			}
			{
				formEntidade &&
					<FormDialog
						operacao={formEntidade.idSerie ? EFORM.UPDATE : EFORM.ADD}
						entidade={formEntidade}
						setEntidade={setFormEntidade}
						openDialog={openDialog}
						listViews={formView}
						setOpenDialog={setOpenDialog}
						callBack={() => 
						{
							setEhCarregado(false);
							getList();
						}}
					/>
			}
		</PageContext.Provider>
	</>
}
export default ListaProgramas;